export default __webpack_public_path__ + "static/media/darwinlogoInduction.73828c31.svg";